import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=7ecdc195"
import script from "./Radio.vue?vue&type=script&lang=ts&setup=true"
export * from "./Radio.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Radio.vue?vue&type=style&index=0&id=7ecdc195&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports